<template>
  <div
    v-if="resultCount > pagination.perPage"
  >
    <ul
      class="Pagination"
      data-cy-id="search-pagination"
    >
      <!-- Prev Button -->
      <li
        class="Pagination-item Pagination--arrow"
        data-cy-id="search-pagination-previous"
      >
        <a
          v-if="showPrevButton"
          :href="pagination.quickNavigation.previousPageUrl"
          title="Pagination left"
          class="Pagination-button Pagination--arrowButton Pagination--left"
          @click.prevent="changePage(pagination.quickNavigation.previousPageUrl,pagination.currentPage - 1)"
        >
          <span class="far fa-chevron-left" />
        </a>
        <div
          v-else
          class="Pagination-button Pagination--arrowButton disabled  Pagination--left"
        >
          <span class="far fa-chevron-left" />
        </div>
      </li>

      <!-- Middle Pages Buttons e.g. 2,3,4,5 -->
      <template v-if="pagination.pages">
        <li
          v-for="page in pagination.pages"
          :key="page.url"
          :class="[{page}, 'Pagination-item Pagination--pageNumber']"
        >
          <a
            :title="'page '+page.page"
            :href="page.url"
            :class="[{'is-active': activePage(page.page)}, 'Pagination-button']"
            :aria-label="`Go to page number ${page.page}`"
            type="button"
            @click.prevent="changePage(page.url,page.page)"
          >
            {{ page.page }}
          </a>
        </li>
      </template>
      <!-- Next Button -->
      <li
        class="Pagination-item"
        data-cy-id="search-pagination-next"
      >
        <a
          v-if="showNextButton"
          :href="pagination.quickNavigation.nextPageUrl"
          title="Pagination right"
          class="Pagination-button Pagination--arrowButton Pagination--right"
          @click.prevent="changePage(pagination.quickNavigation.nextPageUrl,pagination.currentPage + 1)"
        >
          <span class="far fa-chevron-right" />
        </a>
        <div
          v-else
          class="Pagination-button Pagination--arrowButton disabled  Pagination--right"
        >
          <span class="far fa-chevron-right" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'SearchPagination',
  data() {
    return {
      maxVisibleButtons: 5,
    };
  },

  computed: {
    ...mapState('search', {
      resultCount: (state) => state.resultCount,
      pagination: (state) => state.pagination,
    }),

    showPrevButton() {
      return this.pagination.quickNavigation.previousPageUrl !== null;
    },

    showNextButton() {
      return this.pagination.quickNavigation.nextPageUrl !== null;
    },
  },

  methods: {
    ...mapMutations('search', {
      updateQueryPage: 'updateQueryPage',
      updateSearchUrl: 'updateSearchUrl',
    }),
    activePage(page) {
      return this.pagination.currentPage === page;
    },
    changePage(url, pageNumber) {
      this.updateSearchUrl(url);
      this.updateQueryPage({ page: pageNumber });

      setTimeout(() => {
        window.scrollTo(67, 100);
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../scss/abstracts/abstracts";

  .Pagination {
    display: flex;
    margin: 2rem 0 1rem 0;
    justify-content: space-between;
    @include respond-to(md) {
      justify-content: center;
    }
  }

  .Pagination-item {
    display: inline-block;
    vertical-align: middle;
  }

  .Pagination--pageNumber {
    display: none;
    @include respond-to(md) {
      display: block;
    }
  }

  .Pagination-button {
    width: 40px;
    height: 40px;
    background: color('white');
    text-align: center;
    line-height: 40px;
    flex-shrink: 0;
    display: block;
    margin-left: -1px;
    border: 1px solid color('grey', 'light');
    &.Pagination--arrowButton {
      width: 80px;
      font-size: 15px;
    }
    &:hover, &:focus {
      background: color('grey', 'light');
      color:  color('green');
    }
    &.is-active,
    &.is-active:hover {
      background: color($primary-color);
      border-color: color($primary-color);
      color: color('white');
    }

  }

  .Pagination--right {
    border-radius: 0 4px 4px 0
  }

  .Pagination--left {
    border-radius: 4px 0 0 4px
  }

  .disabled {
    background: color('white');
    color: color('grey', 'light');
    &:hover, &:focus {
      color: color('grey', 'light');
      background: color('white');
    }
  }
</style>
